module.exports = __webpack_public_path__ + "img/material_analyze_to_excel_style2.450de61d.png";